import React, { useEffect } from 'react';
import { Container, Row, Col, Image } from 'react-bootstrap';
import Myimage from './Assets/Myimage.jpeg';

export default function About() {
  useEffect(() => {
    window.scrollTo(0, 0);

  }, []);

  return (
    <div style={{ backgroundColor: '#f6f5ff' }}>
      <center><h1 className='p-5'>ABOUT ME</h1></center>
      <Container>
        <Row className="about">
          <Col sm={12} md={6}>
            <p className='fs-4 fw- mt-5'>Hi👋🏻 I am a FULL Stack Web developer, with skills HTML, CSS, JavaScript, BootStrap, React, Node.js and MySQL</p>
          </Col>
          <Col sm={12} md={6} className="text-center">
            <div style={{ maxWidth: '245px', maxHeight: '245px', overflow: 'hidden', borderRadius: '50%', margin: 'auto' }}>
              <Image src={Myimage} style={{ width: '100%', height: 'auto' }} fluid alt="Missing" />
            </div>
          </Col>
        </Row>
      </Container>
      <hr />
      <div className="languages mt-5">
        <center><h1 className='fw-bold'>SCRIPTING LANGUAGES</h1></center>
        <div className="languages1 d-flex justify-content-center flex-wrap">
          <i className="fab fa-html5 rounded-3 p-4 border border-primary m-3 icon" style={{ fontSize: '4rem', margin: '10px' }}></i>
          <i className="fab fa-css3-alt rounded-3 p-4 border border-primary  m-3 icon" style={{ fontSize: '4rem', margin: '10px' }}></i>
          <i className="fab fa-bootstrap rounded-3 p-3 border border-primary  m-3 icon" style={{ fontSize: '4rem', margin: '10px' }}></i>
        </div>


        <center><h1 className='fw-bold mt-5'>PROGRAMMING LANGUAGES</h1></center>
        <div className="languages1 d-flex justify-content-center flex-wrap">
          <i className="fab fa-java rounded-3 p-4 border border-primary m-3 icon" style={{ fontSize: '4rem', margin: '10px' }}></i>
          <i className="fab fa-square-js rounded-3 p-4 border border-primary m-3 icon" style={{ fontSize: '4rem', margin: '10px' }}></i>
        </div>

        <center><h1 className='fw-bold mt-5'>FRAMEWORKS</h1></center>
        <div className="languages1 d-flex justify-content-center flex-wrap">
          <i className="fab fa-node rounded-3 p-4 border border-primary m-3 icon" style={{ fontSize: '4rem', margin: '10px' }}></i>
          <i className="fab fa-react rounded-3 p-4 border border-primary m-3 icon" style={{ fontSize: '4rem', margin: '10px' }}></i>
        </div>

        <center><h1 className='fw-bold mt-5'>DATABASE</h1></center>
        <div className="languages1 d-flex justify-content-center">
        <img src="https://cdn.iconscout.com/icon/free/png-512/free-mysql-3628352-3032187.png?f=webp&w=512" alt="" srcset=""  className="fab fa-mysql rounded-3 p-4 border border-primary m-3 icon" style={{ width: '8rem', margin: '10px' }}/>
      </div>

        <center><h1 className='fw-bold mt-5'>VERSION CONTROL</h1></center>
        <div className="languages1 d-flex justify-content-center">
          <i className="fab fa-github rounded-3 p-4 border border-primary m-3 icon" style={{ fontSize: '4rem', margin: '10px' }}></i>
        </div>

        <center><h1 className='fw-bold mt-5'>OPERATING SYSTEMS</h1></center>
        <div className="languages1 d-flex justify-content-center flex-wrap">
          <i className="fab fa-windows rounded-3 p-4 border border-primary m-3 icon" style={{ fontSize: '4rem', margin: '10px' }}></i>
          <i className="fab fa-apple rounded-3 p-4 border border-primary m-3 icon" style={{ fontSize: '4rem', margin: '10px' }}></i>
          <i className="fab fa-linux rounded-3 p-4 border border-primary m-3 icon" style={{ fontSize: '4rem', margin: '10px' }}></i>
          <i className="fab fa-ubuntu rounded-3 p-4 border border-primary m-3 icon" style={{ fontSize: '4rem', margin: '10px' }}></i>
          <i class="fa-brands fa-android rounded-3 p-4 border border-primary m-3 icon" style={{ fontSize: '4rem', margin: '10px' }}></i>
        </div>
      </div>
      <br /> <br />
      <div className="footer bg-secondary text-white p-3">
      <Container className="px-0">
      <Row className="justify-content-center align-items-center">
        <Col xs={12} sm={4} className="mb-3 mb-sm-0 text-center text-sm-start">
          <h6>Designed & Developed by <a href="https://www.linkedin.com/in/arenaveenkumar" target="_blank" rel="noopener noreferrer" style={{ textDecoration: 'none' }}><strong className='text-warning'>ARE NAVEEN KUMAR</strong></a></h6>
        </Col>
        <Col xs={12} sm={4} className="text-center mb-4 mb-sm-0">
          <h6 className="mb-0"><i className="fa-regular fa-copyright "></i> Copyright-2024</h6>
        </Col>
        <Col xs={12} sm={4} className="d-flex justify-content-center justify-content-sm-end">
          <a href="https://www.linkedin.com/in/arenaveenkumar/" className="text-white me-3" target="_blank" rel="noopener noreferrer"><i className="fa-brands fa-linkedin-in fs-4"></i></a>
          <a href="https://github.com/arenaveenkumar" className="text-white me-3" target="_blank" rel="noopener noreferrer"><i className="fa-brands fa-github fs-4"></i></a>
          <a href="https://www.instagram.com/arenaveenkumar_" className="text-white me-3" target="_blank" rel="noopener noreferrer"><i className="fa-brands fa-instagram fs-4"></i></a>
          <a href="https://wa.me/918096858075" className="text-white" target="_blank" rel="noopener noreferrer"><i className="fa-brands fa-whatsapp fs-4"></i></a>

        </Col>
      </Row>
    </Container>
      </div>
    </div>
  );
}
